"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SecondsToMinutes = function (time) {
    var t = time;
    var minutes = Math.floor(t / 60);
    t -= minutes * 60;
    var seconds = parseInt((t % 60).toString(), 10);
    var secondsStr = seconds < 10 ? "0" + seconds : seconds.toString();
    return minutes + "m" + secondsStr + "s";
};
exports.SecondsToMinutes = SecondsToMinutes;
//# sourceMappingURL=seconds-to-minutes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/seconds-to-minutes.js
// module id = 883
// module chunks = 3